<template>
  <div class="pageContainer">
    <md-content>
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <h1>Search Apple Order ID</h1>

        <form @submit.prevent="searchAppleOrder">
          <md-field>
            <label>Apple Order ID</label>
            <md-input v-model="form.orderIdInput" />
          </md-field>

          <md-field>
            <label>App</label>
            <md-select
              v-model="form.appIdentityInput"
            >
              <md-option value="com.macpaw.clearvpn.ios">
                iOS
              </md-option>
              <md-option value="com.macpaw.clearvpn.macosmas">
                macOS Mac App Store
              </md-option>
            </md-select>
          </md-field>

          <md-button
            type="submit"
            class="md-raised md-primary"
          >
            Search
          </md-button>

          <span
            v-if="form.error"
            class="error"
          >{{ form.error }}</span>
        </form>
      </div>
    </md-content>

    <hr>

    <md-content v-if="$hasValidResult">
      <div class="resultContainer">
        <div>
          <label><b>User:</b></label>{{ ' ' }}
          <a
            v-if="searchResult.account_id"
            :href="`/user/${searchResult.account_id}`"
            target="_blank"
          >{{ searchResult.account_id }}</a>
        </div>

        <br>

        <static-info-field
          label="Original Transaction ID"
          :value="searchResult.original_transaction_id"
        />

        <br>

        <static-info-field
          label="App Account Token"
          :value="searchResult.app_account_token || 'N/A'"
        />
      </div>
    </md-content>

    <md-content v-else>
      <div class="pageContainer">
        No match(
      </div>
    </md-content>
  </div>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators";

import StaticInfoField from "../components/UserDetails/StaticInfoField";

export default {
  components: {
    StaticInfoField
  },
  data() {
    return {
      form: {
        orderIdInput: "",
        appIdentityInput: "com.macpaw.clearvpn.ios",

        isLoading: false,
        error: null,
      },

      searchResult: {},
    };
  },
  computed: {
    $hasValidResult() { 
      return this.searchResult.original_transaction_id || this.searchResult.account_id || this.searchResult.app_account_token;
    }
  },
  methods: {
    searchAppleOrder() {
      this.form.isLoading = true;
      this.form.error = null;
      this.searchResult = {};
      this.$v.form.$touch();

      if (this.$v.form.$error) {
        return;
      }

      this.$http.post("/v1/admin/store/apple/order/lookup", {
        order_id: this.form.orderIdInput,
        app_identity: this.form.appIdentityInput,
      }).then((response) => {
        this.searchResult = response.data;
      }, (error) => {
        console.error(error);
        this.form.error = error.response.data.message || "Something went wrong";
      }).finally(() => {
        this.form.isLoading = false;
      });
    },
  },
  validations: {
    form: {
      orderIdInput: {
        required,
        minLength: minLength(5),
      },
    },
  },
};
</script>

<style lang="scss" scoped>
  .pageContainer {
    max-width: 800px;
    padding: 20px;
  }

  .resultContainer {
    padding: 20px;
  }

  .error {
    display: block;
    color: red;
  }
</style>

